import to from 'await-to-js'
import { ALERT_COLORS, MESSAGE_ERROR, ALERT_DELAY } from '@App/constantes'
import { API_URL } from '@App/configs/rest'
import Fetch from '@App/helpers/fetch'
import { setAlertBox } from '@App/actions/snackbar'
import { Constants, IApplication, ApplicationActionTypes } from './types'

const fetchGetApplications = new Fetch()

export function setApplications(
  applications: IApplication[],
): ApplicationActionTypes {
  return {
    type: Constants.SET_APPLICATIONS,
    payload: applications,
  }
}

export function setCurrentApp(
  applications: IApplication | null,
): ApplicationActionTypes {
  return {
    type: Constants.SET_CURRENT,
    payload: applications,
  }
}

export function getApplications(): IApplication[] | any {
  return async (dispatch: any) => {
    const [err, data] = await to(
      fetchGetApplications.get({
        url: `${API_URL}/applications`,
        params: {
          include: ['application_segments'],
        },
        headers: {},
      }),
    )

    if (!err && data) {
      dispatch(setApplications(data))
      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}

export function updateApplication(id, body): IApplication[] | any {
  return async (dispatch: any) => {
    const [err, data] = await to(
      fetchGetApplications.put({
        body: {
          id,
          ...body,
        },
        url: `${API_URL}/applications/${id}`,
        headers: {},
      }),
    )

    if (!err && data) {
      dispatch(getApplications())
      dispatch(
        setAlertBox({
          title: `L'application "${data.name}" à bien été modifié`,
          background: ALERT_COLORS.green,
          delay: ALERT_DELAY,
        }),
      )
      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}

export function createApplication(body): IApplication[] | any {
  return async (dispatch: any) => {
    const [err, data] = await to(
      fetchGetApplications.post({
        body: {
          ...body,
          icon: '',
        },
        url: `${API_URL}/applications/`,
        headers: {
          'content-type': 'application/json',
        },
      }),
    )

    if (!err && data) {
      dispatch(
        setAlertBox({
          title: `L'application "${data.name}" à bien été créé`,
          background: ALERT_COLORS.green,
          delay: ALERT_DELAY,
        }),
      )
      dispatch(getApplications())
      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}

export function deleteApp(id): IApplication[] | any {
  return async (dispatch: any) => {
    const [err] = await to(
      fetchGetApplications.delete({
        url: `${API_URL}/applications/${id}`,
        params: null,
        body: {},
      }),
    )

    if (err) {
      return dispatch(
        setAlertBox({
          title: err?.message || '',
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )
    }

    dispatch(
      setAlertBox({
        title: "L'application à bien été supprimé",
        background: ALERT_COLORS.green,
        delay: ALERT_DELAY,
      }),
    )

    dispatch(getApplications())
  }
}
